/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseString } from '../../models/api-response-string';

export interface SyncCatalog$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function syncCatalog(http: HttpClient, rootUrl: string, params: SyncCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
  const rb = new RequestBuilder(rootUrl, syncCatalog.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseString>;
    })
  );
}

syncCatalog.PATH = '/v1/api/ui/meta-catalog/sync-products';
